//
// Generated class VenueEventType
//

/// <reference path="VenueEventType_ManagedObject.ts" />

class VenueEventType extends VenueEventType_ManagedObject
{

}
